var map = {
	"./promotion_black.png": "497a",
	"./promotion_blue.png": "2909",
	"./promotion_green.png": "e2a5",
	"./promotion_orange.png": "67dd",
	"./promotion_pink.png": "a0de",
	"./promotion_purple.png": "c832",
	"./promotion_red.png": "536f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c411";